import React from 'react';
import Banner from './Banner';
import ServiceTwo from './ServiceTwo';
import AboutTwo from './AboutTwo';
import CounterTwo from './CounterTwo';
import ProjectTwo from './ProjectTwo';
import TestimonialTwo from './TestimonialTwo';
import SlidingTextOne from '../../components/Common/SlidingTextOne ';
import TeamTwo from './TeamTwo';
import ServiceThree from './ServiceThree';
import FAQTwo from './FAQTwo';
import BlogTwo from './BlogTwo';
import ServicesOne from './ServicesOne';
import TestimonialOne from './TestimonialOne'
import BrandOne from './BrandOne';
import ProjectThree from './ProjectThree';
import FaqOne from './FaqOne';
import { Helmet } from 'react-helmet';
import MissionVisionPage from '../../components/Layout/MissionVisionPage';


const HomeTwoMain = () => {
	return (
		<>  <Helmet>
		     <title>Home - techtotalers</title>
	        </Helmet>
			<Banner />
			<MissionVisionPage />
			<ServicesOne />
			<BrandOne/>
			<FaqOne />
			<ProjectThree />
			<TestimonialOne />
		</>
	);
}

export default HomeTwoMain;
